import { render, staticRenderFns } from "./SignupPhoneGroup.vue?vue&type=template&id=33bd91d1&"
import script from "./SignupPhoneGroup.vue?vue&type=script&lang=js&"
export * from "./SignupPhoneGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports